import React from "react";
import { IconProps } from "./IconProps";

const HashStraightIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  if (size !== "20" || thickness !== "Thin") return null;

  return (
    <svg
      aria-label={ariaLabel}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.75 2.5v15M13.25 2.5v15M3 7h14M3 13h14"
        stroke={color}
        strokeWidth="1"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default HashStraightIcon;